import styled from 'styled-components';
import tinycolor from 'tinycolor2';
import { KioskProLogo } from 'src/components/kiosk-pro/kiosk-pro-shared/kiosk-pro-logo';
import { Search } from 'src/dispensary/core-menu/components/header/search';
import { KIOSK_PRO_MEDIA, kioskTouchHints } from 'src/components/kiosk-pro/kiosk-pro-shared/kiosk-pro-shared.styles';

export const KioskProNavContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: inherit;
  height: 100vh;
  padding: 0 24px;
  background: inherit;
  color: ${({ theme }) => theme.colors.grey[30]};
  z-index: 30;

  @media (orientation: portrait) {
    position: fixed;
    height: auto;
    padding: 24px 36px 0;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    padding: 20px 28px 0;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    padding: 0 16px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    padding: 16px 24px 0;
  }
`;

export const LogoSearchContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (orientation: landscape) {
    margin-top: 24px;
    margin-bottom: 32px;
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    margin-top: 20px;
    margin-bottom: 28px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    margin-top: 16px;
    margin-bottom: 24px;
  }

  @media (orientation: portrait) {
    flex-direction: row;
    align-items: center;
    margin-top: 0;
    margin-bottom: 24px;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    margin-bottom: 20px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    margin-bottom: 16px;
  }
`;

export const LogoMenuRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (orientation: portrait) {
    flex-shrink: 0;
    gap: 24px;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    gap: 20px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    gap: 16px;
  }
`;

export const StyledKioskProLogo = styled(KioskProLogo)`
  max-width: 80px;
  padding: 0;
  transition: opacity 300ms ease-in-out;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    max-width: 60px;
  }
`;

export const SearchContainer = styled.div`
  width: 100%;
  padding: 0;

  @media (orientation: landscape) {
    margin-top: 60px;
    margin-bottom: 24px;
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    margin-top: 50px;
    margin-bottom: 20px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    margin-top: 40px;
    margin-bottom: 16px;
  }

  @media (orientation: portrait) {
    flex: 1;
    margin: 0;
    position: relative;
    z-index: 10;
  }
`;

export const StyledSearch = styled(Search)`
  font-size: 24px;
  color: #485255;
  font-weight: 600;

  input::placeholder {
    color: #485255;
    font-weight: 600;
  }

  svg {
    left: 20px;
    width: 20px;
    height: 20px;
  }

  input[type='text'] {
    padding: 35px 30px 35px 56px;
    font-weight: 600;
    color: #485255;
  }

  @media (orientation: portrait) {
    & > div {
      right: 0;
      left: 0;
      width: calc(100% - 140px);
      margin-left: 140px;
      transition: width 300ms ease-in-out, margin-left 300ms ease-in-out;
    }

    &:focus-within > div {
      width: calc(100% - 20px);
      margin-left: 20px;
    }
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 20px;

    & > div {
      width: calc(100% - 70px);
      margin-left: 70px;
      transition: width 300ms ease-in-out, margin-left 300ms ease-in-out;
    }

    input[type='text'] {
      padding: 24px 24px 24px 56px;
    }
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    font-size: 16px;

    input[type='text'] {
      padding: 24px 24px 24px 48px;
    }
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    font-size: 20px;

    input[type='text'] {
      padding: 31px 30px 31px 56px;
    }
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    font-size: 16px;

    input[type='text'] {
      padding: 24px 24px 24px 48px;
      font-size: 16px;
    }

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

export const MenuTypeContainer = styled.div`
  width: 120px;
  justify-self: start;
  color: ${({ theme }) => theme.colors.black};
  font-size: 18px;

  > div > div {
    font-size: 18px;
  }

  button {
    color: ${({ theme }) => theme.colors.black};
    font-size: 18px;
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    > div > div {
      font-size: 16px;
    }
    button {
      font-size: 16px;
    }
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly}, ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    > div > div {
      font-size: 14px;
    }
    button {
      font-size: 14px;
    }
  }

  [class^='menu-type__SingleMenuType'] {
    color: ${({ theme }) => theme.colors.black};
  }

  @media (orientation: landscape) {
    justify-self: end;
  }
`;

export const NavMenuContainer = styled.nav`
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;

  li {
    list-style: none;
  }

  @media (orientation: portrait) {
    flex-direction: row;
    justify-content: flex-start;
    padding: 40px 36px;
    gap: 72px;
  }
  @media (orientation: landscape) {
    gap: 36px;
    padding: 24px 0;
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    gap: 28px;
    padding: 20px 0;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    gap: 24px;
    padding: 16px 0;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    padding: 36px 20px;
    gap: 56px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    padding: 32px 16px;
    gap: 48px;
  }
`;

export const NavLink = styled.a`
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  color: #485255;
  font-weight: 600;
  font-size: 24px;
  cursor: pointer;
  ${kioskTouchHints}

  & > svg {
    width: 24px;
    height: 24px;
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 20px;
    gap: 16px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly}, ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    gap: 14px;
    font-size: 16px;
  }
`;

export const HomeNavLink = styled(NavLink)`
  & > svg {
    width: 24px;
    height: 24px;
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    & > svg {
      width: 20px;
      height: 20px;
    }
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    & > svg {
      width: 16px;
      height: 16px;
    }
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    & > svg {
      padding: 0 2px;
      width: 20px;
      height: 20px;
    }
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    & > svg {
      padding: 0 4px;
    }
  }
`;

export const CategoriesNavLink = styled(NavLink)`
  @media (orientation: portrait) {
    order: 5;
    padding-right: 30px;
    margin-left: auto;
  }
`;

export const CategoriesChevron = styled.div`
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  width: 20px;
  height: 20px;

  svg {
    transform: rotate(270deg);
  }

  @media (orientation: portrait) {
    right: 0;

    svg {
      transform: rotate(0deg);
    }
  }
`;

export const CategoriesAndCollectionsContainer = styled.div`
  position: fixed;
  top: 0;
  left: 400px;
  width: 380px;
  height: 100vh;
  padding: 20px;
  background: ${({ theme }) => tinycolor.mix(theme.customized.colors.buttonsLinks, '#fff', 90).toString()};
  overflow-y: auto;
  overflow-x: auto;
  scrollbar-width: none;
  z-index: 25;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (orientation: landscape) {
    left: 400px;
    width: 480px;
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    left: 320px;
    width: 460px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    left: 280px;
    width: 440px;
  }

  @media (orientation: portrait) {
    top: 220px;
    left: 0;
    right: 0;
    width: 100%;
    height: auto;
    padding: 0 24px;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    top: 180px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    top: 160px;
  }
`;

export const GradientBottom = styled.div<{ isVisible: boolean }>`
  display: block;
  transform: translateZ(0);
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  pointer-events: none;
  position: fixed;
  bottom: 0;
  left: 400px;
  width: 480px;
  height: 100px;
  z-index: 10;
  will-change: opacity;
  transition: opacity 0.1s;
  background: linear-gradient(
    to bottom,
    ${({ theme }) => tinycolor.mix(theme.customized.colors.buttonsLinks, '#fff', 90).setAlpha(0).toRgbString()},
    ${({ theme }) => tinycolor.mix(theme.customized.colors.buttonsLinks, '#fff', 90).setAlpha(1).toRgbString()} 100%
  );

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    left: 320px;
    width: 460px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    left: 280px;
    width: 440px;
  }
`;

export const GridLayout = styled.div`
  display: block;

  @media screen and (orientation: portrait) {
    display: none;
  }
`;

export const CarouselLayout = styled.div`
  display: none;

  @media screen and (orientation: portrait) {
    display: block;
  }

  [class*='carousel-v2__GradientLeft'] {
    background: linear-gradient(
      to left,
      ${({ theme }) => tinycolor.mix(theme.customized.colors.buttonsLinks, '#fff', 90).setAlpha(0).toRgbString()},
      ${({ theme }) => tinycolor.mix(theme.customized.colors.buttonsLinks, '#fff', 90).setAlpha(1).toRgbString()} 100%
    ) !important;
  }

  [class*='carousel-v2__GradientRight'] {
    background: linear-gradient(
      to right,
      ${({ theme }) => tinycolor.mix(theme.customized.colors.buttonsLinks, '#fff', 90).setAlpha(0).toRgbString()},
      ${({ theme }) => tinycolor.mix(theme.customized.colors.buttonsLinks, '#fff', 90).setAlpha(1).toRgbString()} 100%
    ) !important;
  }
`;

export const Divider = styled.div`
  border-top: 2px solid ${({ theme }) => theme.colors.grey[90]};
`;

export const CategoriesOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 20;
`;
